import { LogoutVariantIcon } from './LogoutVariantIcon';

/**
 * author: Austin Andrews
 * id FD2A4CE0-AD1F-45D4-B487-BB6E57F2143F
 * name logout-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/logout-variant.svg
 * tags
 */
export const SignOutVariantIcon = LogoutVariantIcon;
export default SignOutVariantIcon